import { put, takeEvery, all, select, takeLeading } from 'redux-saga/effects';
import * as constants from '../constants/message';
import * as messagesPageActions from '../actions/messages';
import { SecurityContextType, MessageState } from '../../models/components/messages';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import { MessagesService } from '../../api/message-services';
import { IContactOrGroupRequest, IMessageListRequest } from '../../models/pages/messages';
import { IAppState } from '../../models/action/core';
import { Notification } from '../../components/notification/main';
import { CacheService } from '../../core/cacheService';
import { IActionRequestDate } from '../../models/core/action-request';
import * as coreActions from '../actions/core';
import { BackgroundService } from '../../api/background-service';
import { useState } from 'react';

const T = Translator.create();
const _logger = Log.create('messagePage Saga');
const messagesService = new MessagesService();
const _cacheService = new CacheService();
const _backgroundService = new BackgroundService();

function* getUnreadMessageCount(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const response = yield messagesService
            .RequestGetUnreadMessageCountAsync(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            })
            .then(response => {
                if (isError) {
                    errorList = response;
                } else {
                    return response;
                }
            });
       
        if (isError) {
            errorList
                ? Object.keys(errorList).forEach((key: any) => {
                      Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                  })
                : Notification.setNotification('error', T.t('r_get_unread_message_count_error_message'), 'topRight');
        }

        if (!isError) {
            yield put(messagesPageActions.setUnreadMessageCountAction(response, params.spinnerId));
            if (params.callback) {
                params.callback();
            }
            if(params.showTopNotification && response.unreadMessageCount && response.unreadMessageCount> 0) {
                      
                Notification.setNotification('success', T.t('r_new_notification'), 'topRight');
            }
        }
    } catch (error: any) {
        _logger.error('Calling RequestGetClassMatesAsync ', error);
    }
    return null;
}

function* getContacts(params: any): any {
    try {
        const response = yield messagesService
            .RequestGetContactsAsync(params.params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (data === undefined || data === false) {
                    return null;
                } else {
                    return data;
                }
            });
        yield put(
            messagesPageActions.setContactsAction(
                params.params.take,
                params.params.skip,
                response.totalCount,
                response.contacts,
                params.spinnerId,
                'set'
            )
        );
    } catch (error: any) {
        _logger.error('Calling RequestGetClassMatesAsync ', error);

        yield put(messagesPageActions.setContactsAction(50, 0, 0, [], params.spinnerId, 'set'));
    }
    return null;
}

function* getGroups(params: any): any {
    try {
        const response = yield messagesService
            .RequestGetGroupsAsync(params.params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (data === undefined || data === false) {
                    return null;
                } else {
                    return data;
                }
            });
        yield put(
            messagesPageActions.setGroupsAction(
                params.params.take,
                params.params.skip,
                response.totalCount,
                response.groups,
                params.spinnerId,
                'set'
            )
        );
    } catch (error: any) {
        _logger.error('Calling RequestGetClassMatesAsync ', error);

        yield put(messagesPageActions.setGroupsAction(50, 0, 0, [], params.spinnerId, 'set'));
    }
    return null;
}

function* getMessageListData(params: any): any {
    try {
        const response = yield messagesService
            .RequestGetMessagesAsync(params.params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (data === undefined || data === false) {
                    return null;
                } else {
                    return data;
                }
            });
        yield put(
            messagesPageActions.setMessageListAction(
                response.messages,
                params.params.originMessageId,
                params.params.skip,
                params.params.take,
                response.totalCount,
                params.params.chatTitleText,
                params.params.imageUrl,
                params.params.contextId,
                params.params.contextType,
                params.params.spinnerId,
                'set'
            )
        );
        // refresh user messages
        yield put(
            messagesPageActions.getConversationListAction({
                skip: 0,
                take: 10,
                keyword: '',
                spinnerId: 'getConversationsAction',
                spinnerType: 'get',
                isGroup: false
            })
        );

        // refresh group messages
        yield put(
            messagesPageActions.getConversationListAction({
                skip: 0,
                take: 10,
                keyword: '',
                spinnerId: 'getConversationsAction',
                spinnerType: 'get',
                isGroup: true
            })
        );

        if (params.callback) {
            params.callback();
        }
    } catch (error: any) {
        _logger.error('Calling RequestGetMessagesAsync ', error);

        yield put(
            messagesPageActions.setMessageListAction(
                [],
                null,
                params.params.skip,
                params.params.take,
                params.params.total,
                params.params.chatTitleText,
                params.params.imageUrl,
                params.params.contextId,
                params.params.contextType
            )
        );
    }
    return null;
}

function* getLoadMoreMessages(params: any): any {
    try {
        const response = yield messagesService
            .RequestGetMessagesAsync(params.params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (data === undefined || data === false) {
                    return null;
                } else {
                    return data;
                }
            });
        yield put(
            messagesPageActions.setLoadMoreMessages(
                response.messages,
                params.params.originMessageId,
                params.params.skip,
                params.params.take,
                response.totalCount,
                params.params.chatTitleText,
                params.params.imageUrl,
                params.params.contextId,
                params.params.contextType,
                params.params.spinnerId,
                'set'
            )
        );
    } catch (error: any) {
        _logger.error('Calling RequestGetMessagesAsync ', error);

        yield put(
            messagesPageActions.setLoadMoreMessages(
                [],
                null,
                params.params.skip,
                params.params.take,
                params.params.total,
                params.params.chatTitleText,
                params.params.imageUrl,
                params.params.contextId,
                params.params.contextType
            )
        );
    }
    return null;
}

export const getMessage = (state: IAppState) => state.message;

function* sendMessage(params: any): any {
    try {
        const newMessageResponse = yield messagesService
            .RequestSendMessageAsync(params.params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any) => {
                if (data === undefined || data === false) {
                    return null;
                } else {
                    if(params.callback){
                        params.callback(data);

                    }
                    return data;
                }
            });

        if (!newMessageResponse) {
            Notification.setNotification('error', T.t('r_message_page_send_message_error_message'), 'topRight');

            throw new Error('no-message-id');
        }

        const newMessageId = newMessageResponse.messageId;
        const newOriginMessageId = newMessageResponse.originMessageId;

        const messageState = yield select(getMessage);

        let originMessageId = messageState.originMessageId as string;

        if (!originMessageId || originMessageId === '-1') {
            originMessageId = newOriginMessageId;
        }

        // Message Email Send
        if (newOriginMessageId != '') {
            _backgroundService
                .RequestGetMessageEmailAsync(newMessageId, newOriginMessageId)
                .then((newMessageResponse: Response) => {
                    return newMessageResponse;
                })
                .then((responseData: Response) => {
                    return newMessageResponse;
                });
        }

    } catch (error: any) {
        _logger.error('Calling RequestSendMessageAsync ', error);
        Notification.setNotification('error', T.t('r_message_page_send_message_error_message'), 'topRight');
    }
    return null;
}

function* getConversationsData(params: any): any {
    try {
        const response = yield messagesService
            .RequestGetConversationsAsync(params.params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (data === undefined || data === false) {
                    return null;
                } else {
                    return data;
                }
            });
        yield put(
            messagesPageActions.setConversationListAction(
                response.totalCount,
                response.conversations,
                params.params.take,
                params.params.isGroup,
                params.spinnerId,
                'set'
            )
        );
        if (params.callback) {
            params.callback();
        }
    } catch (error: any) {
        _logger.error('Calling RequestGetClassMatesAsync ', error);
    }
    return null;
}

function* getHeaderMessageData(params: any): any {
    try {
        const response = yield messagesService
            .RequestGetHeaderMessagesAsync(params.params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (data === undefined || data === false) {
                    return null;
                } else {
                    return data;
                }
            });
        yield put(
            messagesPageActions.setHeaderMessageListAction(
                response.totalCount,
                response.conversations,
                params.spinnerId,
                'set'
            )
        );
        if (params.callback) {
            params.callback();
        }
    } catch (error: any) {
        _logger.error('Calling RequestGetClassMatesAsync ', error);
    }
    return null;
}

function* getHomeBox(params: any): any {
    let isError = false;
    let errorList: any;
    const cacheData: IActionRequestDate = { firstRequestDate: new Date(), actionName: params.type };
    if (params.Filters.lastMessageId) {
        try {
            const pageData = yield messagesService
                .RequestGetConversations(params.Filters, params.IsAll)
                .then((responseData: Response) => {
                    return responseData;
                })
                .then((responseData: Response) => {
                    if (responseData.status !== 200) {
                        isError = true;
                    }
                    return responseData.json();
                })
                .then((response: any) => {
                    if (isError) {
                        errorList = response;
                    } else {
                        return response;
                    }
                });

            if (isError) {
                errorList
                    ? Object.keys(errorList).forEach((key: any) => {
                          Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                      })
                    : Notification.setNotification('error', T.t('r_message_page_my_message_error_message'), 'topRight');
            }

            if (!isError) {
                yield put(
                    messagesPageActions.getHomeBoxSetAction(pageData, params.spinnerId, 'set', params.Filters.lastMessageId ? true : false)
                );
            }
        } catch (error: any) {
            Notification.setNotification('error', T.t('r_message_page_my_message_error_message'), 'topRight');
        }
    } else {
        if (!_cacheService.CheckCache(cacheData)) {
            _cacheService.AddOrUpdateActionRequest(cacheData);
            try {
                const pageData = yield messagesService
                    .RequestGetConversations(params.Filters, params.IsAll)
                    .then((responseData: Response) => {
                        return responseData;
                    })
                    .then((responseData: Response) => {
                        if (responseData.status !== 200) {
                            isError = true;
                        }
                        return responseData.json();
                    })
                    .then((response: any) => {
                        if (isError) {
                            errorList = response;
                        } else {
                            return response;
                        }
                    });

                if (isError) {
                    errorList
                        ? Object.keys(errorList).forEach((key: any) => {
                              Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                          })
                        : Notification.setNotification('error', T.t('r_message_page_my_message_error_message'), 'topRight');
                }

                if (!isError) {
                    if (pageData.length <= 0 && (params.lastMessageId !== null || params.lastMessageId !== '')) {
                        params.lastMessageId = '';
                        // tslint:disable-next-line:no-shadowed-variable
                        const pageData = yield messagesService
                            .RequestGetConversations(params.Filters, params.IsAll)
                            .then((responseData: Response) => {
                                return responseData;
                            })
                            .then((responseData: Response) => {
                                if (responseData.status !== 200) {
                                    isError = true;
                                }
                                return responseData.json();
                            })
                            .then((response: any) => {
                                if (isError) {
                                    errorList = response;
                                } else {
                                    return response;
                                }
                            });

                        if (isError) {
                            errorList
                                ? Object.keys(errorList).forEach((key: any) => {
                                      Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                                  })
                                : Notification.setNotification('error', T.t('r_message_page_my_message_error_message'), 'topRight');
                        }
                        if (!isError) {
                            yield put(messagesPageActions.getHomeBoxSetAction(pageData, params.spinnerId, 'set'));
                        }
                    } else {
                        yield put(messagesPageActions.getHomeBoxSetAction(pageData, params.spinnerId, 'set'));
                    }
                }
            } catch (error: any) {
                Notification.setNotification('error', T.t('r_message_page_my_message_error_message'), 'topRight');
            }
        } else {
            try {
                const pageData = yield messagesService
                    .RequestGetConversations(params.Filters, params.IsAll)
                    .then((responseData: Response) => {
                        return responseData;
                    })
                    .then((responseData: Response) => {
                        if (responseData.status !== 200) {
                            isError = true;
                        }
                        return responseData.json();
                    })
                    .then((response: any) => {
                        if (isError) {
                            errorList = response;
                        } else {
                            return response;
                        }
                    });

                if (isError) {
                    errorList
                        ? Object.keys(errorList).forEach((key: any) => {
                              Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                          })
                        : Notification.setNotification('error', T.t('r_message_page_my_message_error_message'), 'topRight');
                }

                if (!isError) {
                    yield put(
                        messagesPageActions.getHomeBoxSetAction(
                            pageData,
                            params.spinnerId,
                            'set',
                            params.Filters.lastMessageId ? true : false
                        )
                    );
                }
            } catch (error: any) {
                Notification.setNotification('error', T.t('r_message_page_my_message_error_message'), 'topRight');
            }
        }
    }
}

function* getDeleteAllMessages(params: any): any {
    try {
        const pageData = yield messagesService
            .RequestDeleteMessageAsync(params.originMessageId, params.deleteType)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });
        yield put(messagesPageActions.setMessageListAction([], null, 0, 20, 0, '', '', undefined, 0));
        params.callback();
    } catch (error: any) {
        _logger.error('in setDeleteAllMessages', error);
    }
}

function* GetReadMessages(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const myYield = messagesService.RequestReadMessagesAsync().then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                return response;
            }
        });
        const pageData = yield myYield;
        if (isError) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        } else {
           
        }
    } catch (error: any) {
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
    }
}

export function* watchGetMessageListData() {
    yield takeEvery(constants.actions.GET_MESSAGE_LIST, getMessageListData);
    return null;
}

export function* watchGetLoadMoreMessages() {
    yield takeLeading(constants.actions.GET_LOAD_MORE_MESSAGES, getLoadMoreMessages);
    return null;
}

export function* watchSendMessageData() {
    yield takeEvery(constants.actions.SEND_MESSAGE, sendMessage);
    return null;
}
export function* watchGetContactsData() {
    yield takeLeading(constants.actions.GET_CONTACTS, getContacts);
    return null;
}

export function* watchGetGroupsData() {
    yield takeLeading(constants.actions.GET_GROUPS, getGroups);
    return null;
}

export function* watchGetHomeBox() {
    yield takeEvery(constants.actions.GET_HOME_BOX, getHomeBox);
    return null;
}

export function* watchGetDeleteAllMessages() {
    yield takeEvery(constants.actions.GET_DELETE_MESSAGES, getDeleteAllMessages);
    return null;
}

export function* watchGetConversationsData() {
    yield takeEvery(constants.actions.GET_CONVERSATION_LIST, getConversationsData);
    return null;
}

export function* watchGetHeaderMessageData() {
    yield takeEvery(constants.actions.GET_HEADER_MESSAGE_LIST, getHeaderMessageData);
    return null;
}

export function* watchGetUnreadMessageCount() {
    yield takeEvery(constants.actions.GET_UNREAD_MESSAGE_COUNT, getUnreadMessageCount);
    return null;
}

export function* watchGetReadNMessages() {
    yield takeEvery(constants.actions.GET_READ_MESSAGES, GetReadMessages);
    return null;
}

export function* MessageSagas() {
    yield all([
        watchGetContactsData(),
        watchGetGroupsData(),
        watchGetMessageListData(),
        watchGetConversationsData(),
        watchGetHomeBox(),
        watchSendMessageData(),
        watchGetDeleteAllMessages(),
        watchGetLoadMoreMessages(),
        watchGetUnreadMessageCount(),
        watchGetHeaderMessageData(),
        watchGetReadNMessages()
    ]);
}
